export default {
  tab: {
    contribution: 'Tỷ Trọng',
    foreign: 'Nước ngoài',
    proprietary: 'Tự Doanh',
    // proprietary: 'Tổ chức trong nước',
    statistic: 'Phân loại nhà đầu tư',
  },
  tooltipMatched: 'Giá Khớp: ',
  noData: 'Không có dữ liệu',
  noDataSell: 'Bán',
  noDataBuy: 'Mua',
  tooltipDate: 'Dữ liệu được tính từ ngày %{from} đến %{to}',
  tooltipToday: 'Dữ liệu được tính tại %{from}',
  tooltipInvestorToday:
    ' được cập nhật tại %{from}. Dữ liệu chỉ bao gồm sàn HOSE.',
  tooltipInvestorDate:
    ' được cập nhật từ ngày %{from} đến %{to}. Dữ liệu chỉ bao gồm sàn HOSE.',
  tooltipHose: 'Dữ liệu phân loại nhà đầu tư',
  // proprietaryNotice: {
  //   title: 'Thông báo',
  //   content:
  //     'Từ ngày 1/3/2022, dữ liệu Tự doanh được thay thế bằng dữ liệu Tổ chức trong nước <br/> (đã bao gồm dữ liệu Tự doanh).',
  // },
  // statInvestorNotice: {
  //   title: 'Thông báo',
  //   content:
  //     'Từ ngày 1/3/2022, dữ liệu Tự doanh được cộng dồn vào dữ liệu Tổ chức trong nước.',
  // },
};
